const terminalTypeOptions = [
  {
    "key": "ADMINISTRATIVE_TERMINAL",
    "text": "Administrative terminal"
  },
  {
    "key": "POS_TERMINAL",
    "text": "POS terminal"
  },
  {
    "key": "ATM",
    "text": "ATM"
  },
  {
    "key": "HOME_TERMINAL",
    "text": "Home terminal"
  },
  {
    "key": "ECR",
    "text": "ECR"
  },
  {
    "key": "DIAL_TERMINAL",
    "text": "Dial terminal"
  },
  {
    "key": "TRAVELERS_CHECK_MACHINE",
    "text": "Travelers check machine"
  },
  {
    "key": "FUEL_MACHINE",
    "text": "Fuel machine"
  },
  {
    "key": "SCRIP_MACHINE",
    "text": "Scrip machine"
  },
  {
    "key": "COUPON_MACHINE",
    "text": "Coupon machine"
  },
  {
    "key": "TICKET_MACHINE",
    "text": "Ticket machine"
  },
  {
    "key": "POINT_OF_BANKING_TERMINAL",
    "text": "Point of banking terminal"
  },
  {
    "key": "TELLER",
    "text": "Teller"
  },
  {
    "key": "FRANCHISE_TELLER",
    "text": "Franchise teller"
  },
  {
    "key": "PERSONAL_BANKING",
    "text": "Personal banking"
  },
  {
    "key": "PUBLIC_UTILITY",
    "text": "Public utility"
  },
  {
    "key": "VENDING",
    "text": "Vending"
  },
  {
    "key": "SELF_SERVICE",
    "text": "Self service"
  },
  {
    "key": "AUTHORIZATION",
    "text": "Authorization"
  },
  {
    "key": "PAYMENT",
    "text": "Payment"
  },
  {
    "key": "VRU",
    "text": "Vru"
  },
  {
    "key": "SMART_PHONE",
    "text": "Smart phone"
  },
  {
    "key": "INTERACTIVE_TELEVISION",
    "text": "Interactive television"
  },
  {
    "key": "PERSONAL_DIGITAL_ASSISTANT",
    "text": "Personal digital assistant"
  },
  {
    "key": "SCREEN_PHONE",
    "text": "Screen phone"
  },
  {
    "key": "ELECTRONIC_COMMERCE",
    "text": "Electronic commerce"
  },
  {
    "key": "MICR_TERMINAL",
    "text": "Micr terminal"
  },
  {
    "key": "OFF_PREMISE",
    "text": "Off premise"
  }
]

export default terminalTypeOptions;